export interface ActionCatalogItem {
    code: string;
    description: string;
    workflow_id: string;
    autoSaveAfter?: boolean;
    list_action?: boolean;
    icon?: string;
    hover_text?: string;
}

export interface UIConfig {
    entity_editor?: string;
    entity_viewer?: string;
    entity_list_editor?: string;
    entity_list_viewer?: string;
    icon?: string;
    editor_template?: string;
    editor_options?: string;
    create_template?: string;
    create_options?: string;
    filter_template?: string;
    filter_options?: string;
    editable_fields?: string[];
    header_fields?: string[];
    dialog_size?: string;
    translations?: Record<string, Record<string, string>>;
    display_name_cat?: string;
    display_name_en?: string;
    display_name_es?: string;
    hide_default_save?: boolean;
    hide_default_close?: boolean;
    hide_default_back?: boolean;
    hide_create_button?: boolean;
    create_default_payload?: Record<string, any>;
    value_translations?: Record<string, Record<string, string>>;  // {locale: {value: translated_value}}
}

export interface CrudSlotConfig {
    slot_type: string;  // 'create_update', 'delete', 'get', 'filter'
    mode: 'default' | 'workflow' | 'disabled';
    workflow_id?: string;  // UUID of workflow to execute when mode === 'workflow'
}

export interface CrudSlotsConfig {
    create_update?: CrudSlotConfig;
    delete?: CrudSlotConfig;
    get?: CrudSlotConfig;
    filter?: CrudSlotConfig;
}

export class EntityType {
    uuid: string;
    name: string;
    schema: Object;
    user_id: number;
    is_visible: boolean;
    is_protected: boolean;
    ui_config: UIConfig;
    kind: string;
    actions_catalog: ActionCatalogItem[];
    crud_slots: CrudSlotsConfig;

    constructor(
        uuid: string = '',
        name: string = '',
        schema: Object = {},
        user_id: number = 0,
        is_visible: boolean = false,
        ui_config: Object = {},
        kind: string = null,
        is_protected: boolean = false,
        actions_catalog: ActionCatalogItem[] = [],
        crud_slots: CrudSlotsConfig = {}
    ) {
        this.uuid = uuid;
        this.name = name;
        this.schema = schema;
        this.user_id = user_id;
        this.is_visible = is_visible;
        this.is_protected = is_protected;
        if (ui_config === null) {
            ui_config = {'entity_editor': '', 'entity_viewer': '', 'entity_list_editor': '', 'entity_list_viewer': '', 'icon': '', 'editor_template': '', 'editor_options': '', 'create_template': '', 'create_options': '', 'filter_template': '', 'filter_options': '', 'editable_fields':[], 'header_fields': [], 'dialog_size': ''};
        }
        this.ui_config = ui_config;
        this.kind = kind;
        this.actions_catalog = actions_catalog || [];
        this.crud_slots = crud_slots || {};
    }
}

export class EntityInstance {
    uuid: string;
    entity_type_id: string;
    company_id: number;
    payload: Object;
    satisfies_schema: boolean;
    created: string;
    download_date: string;

    constructor(
        uuid: string = '',
        entity_type_id: string = '',
        company_id: number = 0,
        payload: Object = {},
        //satisfies_schema: boolean = false,
        created: string = null, //problemes sino
        download_date: string = ''
    ) {
        this.uuid = uuid;
        this.entity_type_id = entity_type_id;
        this.company_id = company_id;
        if (payload === null) {
            payload = {};
        }
        this.payload = payload;
        //this.satisfies_schema = satisfies_schema;
        this.created = created;
        this.download_date = download_date;
    }
}


export interface EntityTypeRepository {
    get_my_types(): Promise<any>;
    get_aux_workflow_editor_types(): Promise<any>;
    get_type_by_id(type_id: string, explicit:boolean): Promise<EntityType>;
    save(entity_type: EntityType): Promise<any>;
    create_empty_entity_type(): EntityType;
    get_UI_types(): Promise<EntityType[]>;
}

export interface EntityInstanceRepository {
    get_instances_by_type(company_id:number, entity_type_id:string, filters:Array<Object>): Promise<any>;
    save(entity_instance: EntityInstance): Promise<any>;
    create_empty_entity_instance(company_id:number, entity_type:EntityType): EntityInstance;
    get_instance_by_id(instance_id: string): Promise<any>;
    delete_instances(instance_ids:string[]): Promise<void>;
    download_instances(instance_ids:string[]): Promise<any>;
    filter_instances(
        entity_type_id: string,
        company_id: number,
        filters: Array<{match_key: string, value: string}>,
        limit?: number | null,
        offset?: number | null,
        sort_by?: string | null,
        sort_desc?: boolean
    ): Promise<any>;
    create_or_update_instance(
        entity_instance_uuid: string,
        entity_type_uuid: string,
        payload: any,
        company_id: number,
        is_creation?: boolean
    ): Promise<any>;
    delete_entity_instances(
        instance_ids: string[],
        entity_type_uuid: string
    ): Promise<any>;
}